import React, { useContext } from "react";
import { Dropdown, DropdownButton, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AuthContext } from "../../../context/AuthContext";

const DropDownOsPermission = ({ history, permission }) => {
  const { isAllowed } = useContext(AuthContext);

  return isAllowed(permission) ? (
    <DropdownButton id="dropdown-basic-button" title="Nova OS">
      <Dropdown.Item onClick={() => history.push("/app/os/form")}>Individual/Lote</Dropdown.Item>
      <Dropdown.Item onClick={() => history.push({ pathname: "/app/os/origem", state: { tipoOrigem: "D" } })}>
        Denúncia
      </Dropdown.Item>
      <Dropdown.Item onClick={() => history.push({ pathname: "/app/os/origem", state: { tipoOrigem: "P" } })}>
        Parte de Serviço
      </Dropdown.Item>
    </DropdownButton>
  ) : (
    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Acesso negado</Tooltip>}>
      <span className="d-inline-block">
        <DropdownButton style={{ pointerEvents: "none" }} title="Nova OS" disabled />
      </span>
    </OverlayTrigger>
  );
};

export default DropDownOsPermission;
